<template>
  <table class="table is-striped is-hoverable" id="timber-table-average-result">
    <tbody>
      <tr>
        <td>Durchschnitt</td>
        <td>{{ getAverageDiameter() }} cm</td>
      </tr>
      <tr v-if="woodMesauredWithBark">
        <td>Durchschnitt ohne Rinde</td>
        <td>{{ getAverageDiameterWithoutBark() }} cm</td>
      </tr>
      <tr>
        <td>Durchschnittliche Länge</td>
        <td>{{ getAverageLength() }} m</td>
      </tr>
      <tr>
        <td>Gesamtmenge</td>
        <td data-cy="total_volume" >{{ totalVolume }} m³</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import helperMixin from "../mixins/helper-mixin.js";
export default {
  name: "timber-table-average-results",
  mixins: [helperMixin],
  props: {
    rows: Array,
    woodMesauredWithBark: Boolean,
    totalVolume: String
  },
  methods: {
    getAmountOfLogs() {
      var result = this.rows.filter(function(m) {
        return typeof m.diameter === "number" && typeof m.length === "number";
      }).length;

      if (isNaN(result) ) {
        return 0; 
      } else {
        return result;
      }
    },
    getAverageDiameter() {
      var diameterCumulated = this.rows
        .filter(function(m) {
          return typeof m.diameter === "number" && typeof m.length === "number";
        })
        .map(function(m) {
          return m.diameter;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);

      // for the initial case, so we don't show NaN to the user
      var result = diameterCumulated / this.getAmountOfLogs();
      if (isNaN(result) || !isFinite(result)) {
        return 0;
      } else {
        return this.round(result,1);
      }
    },
    getAverageDiameterWithoutBark() {
      var diameterCumulated = this.rows
        .filter(function(m) {
          return typeof m.diameter === "number" && typeof m.length === "number";
        })
        .map(function(m) {
          return m.diameterWithoutBark;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);
      var result = diameterCumulated / this.getAmountOfLogs();
      if (isNaN(result) || !isFinite(result)) {
        return 0;
      } else {
        return this.round(result,1);
      }
    },
    getAverageLength() {
      var lengthCumulated = this.rows
        .filter(function(m) {
          return typeof m.diameter === "number" && typeof m.length === "number";
        })
        .map(function(m) {
          return m.length;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);
        
      var result = lengthCumulated / this.getAmountOfLogs();
      if (isNaN(result) || !isFinite(result)) {
        return 0;
      } else {
        return this.round(result, 2);
      }
    }
    
  }
};
</script>